export const CONNECTOR_TABS = [
  "run",
  "coverage",
  "transit",
  "orders",
  "failed",
  "rights",
  "atrd",
  "journal",
  "settings",
] as const;
export type ConnectorTab = (typeof CONNECTOR_TABS)[number];

export const CONNECTORS_PATH = "/app/admin/connectors";

/** URL de la page d’un module de plateforme, indépendante des filtres d’onglet. */
export function connectorDetailPath(connectorId: string): string {
  return `${CONNECTORS_PATH}/${encodeURIComponent(connectorId)}`;
}
